// --- Mock API Functions ---
export const fetchUserDetails = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const goqiiUserId = urlParams.get("goqiiUserId") || urlParams.get("goqiiuserid");

    const USER_API_URL = `https://apiv4.goqii.com/user/find_user_by_phone?goqiiUserId=${goqiiUserId}&identifier=TEST`;
    try {
        const response = await fetch(USER_API_URL);
        if (!response.ok) throw new Error(`HTTP error fetching user details! status: ${response.status}`);
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error("Error fetching user details:", error);
        return null;
    }
};

export const fetch7DayFoodData = async (userDetails) => {
    if (!userDetails) {
        console.error("Cannot fetch food data without user details.");
        return null;
    }
    const BASE_URL = "https://apiv4.goqii.com/";
    const HEADERS = {
        "Content-Type": "application/json",
        "h-goqiiuserid": userDetails.goqiiUserId.toString(),
        "h-nonce": userDetails.nonce,
        "h-signature": userDetails.signature,
        "h-apikey": userDetails.apiKey,
        "h-goqiiaccesstoken": userDetails.goqiiAccessToken,
        "h-appversion": userDetails.appVersion.toString(),
        "h-apptype": userDetails.appType,
    };
    try {
        const body = { "goqiiUserId": userDetails.goqiiUserId.toString(), "days": "10" };
        const response = await fetch(BASE_URL + "user/fetch_users_health_data", {
            method: 'POST',
            headers: HEADERS,
            body: JSON.stringify(body),
        });
        if (!response.ok) throw new Error(`HTTP error fetching food data! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error("Error fetching 7-day food data:", error);
        return null;
    }
};

export async function addWaterEntry(amount, unit, getCommonHeaders) {
    const url = "https://apiv7.goqii.com/water/add_water";
    console.log("getCommonHeaders(), ", getCommonHeaders())
    // Normalize to milliliters
    let amountInMl = unit === "l" || unit.includes("litre") ? amount * 1000 : amount;
    amountInMl = Math.round(amountInMl); // Ensure it's an integer

    const now = new Date();
    const dateStr = now.toISOString().split("T")[0];
    const timeStr = now.toTimeString().split(" ")[0];

    const payload = {
        data: JSON.stringify([
            {
                serverWaterId: "",
                quantity: amount,
                unit: "ML",
                status: "new",
                localWaterId: `${Date.now()}`, // unique ID
                source: "goqii",
                date: dateStr,
                amountInMl: amountInMl,
                createdTime: `${dateStr} ${timeStr}`
            }
        ])
    };
    console.log("waterPayload(), ", payload)

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify(payload)
        });

        const result = await response.json();
        console.log("✅ Water Add Response:", result);
    } catch (error) {
        console.error("❌ API call failed:", error);
    }
}

export async function addWeightEntry(weightKg, getCommonHeaders) {
    const url = "https://apiv7.goqii.com/weight/add_weight";

    const now = new Date();
    const dateStr = now.toISOString().split("T")[0];
    const timeStr = now.toTimeString().split(" ")[0];

    const payload = [
        {
            weight: weightKg.toFixed(6),
            source: "goqii",
            moisture: "0",
            weightUnit: "KG",
            serverWeightId: "-1",
            status: "new",
            visceralFat: "0",
            waist: "0.000000",
            bodyFat: "0",
            resistance: "0",
            createdTime: `${dateStr} ${timeStr}`,
            date: dateStr,
            bmr: "0",
            bmi: "0",
            protein: "0",
            skeletalMuscle: "0",
            localWeightId: `${Date.now()}`,
            bone: "0",
            targetWeight: "0",
            boneMuscle: "0",
            hip: "0"
        }
    ];

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify({ data: JSON.stringify(payload) })
        });

        const result = await response.json();
        console.log("✅ Weight Add Response:", result);
    } catch (error) {
        console.error("❌ API call failed:", error);
    }
}

export async function addSleepEntry(duration, getCommonHeaders) {
    const url = "https://apiv7.goqii.com/sleep/add_sleep";

    const now = new Date();
    const dateStr = now.toISOString().split("T")[0];
    const timeStr = now.toTimeString().split(" ")[0];
    const sleepStart = new Date(now.getTime() - duration * 60000); // duration minutes ago
    const sleptDate = sleepStart.toISOString().split("T")[0];
    const sleptTime = sleepStart.toTimeString().split(" ")[0];

    const payload = [
        {
            rating: 4,
            logType: "",
            createdTime: `${dateStr} ${timeStr}`,
            localSleepId: Date.now(),
            awakeTime: `${dateStr} ${timeStr}`,
            source: "",
            date: dateStr,
            minutesAsleep: "0",
            timeInBed: "0",
            serverSleepId: "0",
            duration: duration,
            status: "new",
            sleptTime: `${sleptDate} ${sleptTime}`
        }
    ];

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify({ data: JSON.stringify(payload) })
        });

        const result = await response.json();
        console.log("✅ Sleep Add Response:", result);
    } catch (error) {
        console.error("❌ Sleep API call failed:", error);
    }
}

export async function addActivityEntry(activityName, durationMin, intensity, getCommonHeaders) {
    console.log("Logging Activities with info", activityName, durationMin, intensity)
    const url = "https://apiv7.goqii.com/activity/add_multiple_activity";

    const end = new Date();
    const start = new Date(end.getTime() - durationMin * 60000);

    const dateStr = end.toISOString().split("T")[0];
    const startTime = start.toTimeString().split(" ")[0];
    const endTime = end.toTimeString().split(" ")[0];

    const payload = [
        {
            activityTypeName: activityName,
            activityText: "",
            source: "goqii",
            status: "new",
            duration: durationMin.toString(),
            durationSec: (durationMin * 60).toString(),
            logFrom: "manual",
            pointData: "",
            derivedJson: "",
            calories: "", // Optionally calculate or leave blank
            intensity: intensity,
            simplifiedData: "",
            serverActivityId: "1",
            endTime: endTime,
            startTime: startTime,
            createdTime: `${dateStr} ${endTime}`,
            date: dateStr,
            localActivityId: `${Date.now()}`,
            distance: "0.00",
            heartData: "",
            unit: "",
            imageJson: "",
            gpsJson: "",
            imageWidth: "",
            heightAspectRatio: "",
            activityImageUrl: "",
            steps: "",
            activityImage: "",
            description: "",
            jsonData: ""
        }
    ];

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify({ data: JSON.stringify(payload) })
        });

        const result = await response.json();
        console.log("✅ Activity Add Response:", result);
    } catch (error) {
        console.error("❌ Activity API call failed:", error);
    }
}

export async function addFoodEntry(foodName, mealType, userDetails, getCommonHeaders) {
    console.log("Logging Food with info:", foodName, mealType);
    const url = "https://apiv7.goqii.com/food/add_food_v2";

    // compute timestamps
    const now = new Date();
    const dateStr = now.toISOString().split("T")[0];           // YYYY-MM-DD
    const timeStr = now.toTimeString().split(" ")[0];           // HH:MM:SS
    const createdTime = `${dateStr} ${timeStr}`;                // e.g. "2025-05-09 14:30:15"

    // build the payload array—with defaults for everything except name/type
    const payload = [
        {
            recognition: "0",
            unit: "",                       // leave blank or supply if you know
            createdTime,
            calories: "0",                  // leave "0" or compute if you have
            goqiiUserId: userDetails.goqiiUserId,  // replace with actual user ID
            amount: "0",                    // default; supply if you know grams/servings
            foodImageUrl: "",
            localFoodId: `${Date.now()}`,   // unique per‐entry
            foodImage: "",
            source: "goqii",
            healthAnalysis: {
                healthMeter: "5",              // e.g. "5"
                portionCategory: "Medium",          // e.g. "Medium"
                portionSize: "1",              // e.g. "1"
                healthMeterCategory: "Medium",      // e.g. "Medium"
                foodType: "Home"                  // e.g. "Home" or "Restaurant"
            },
            date: dateStr,
            foodName: foodName,
            mealType: mealType,
            times: timeStr,
            serverFoodId: "0",
            status: "new"                   // or "inprogress" per your flow
        }
    ];

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: getCommonHeaders(),             // your existing header helper
            body: JSON.stringify({ data: JSON.stringify(payload) })
        });

        const result = await response.json();
        console.log("✅ Food Add Response:", result);
        return result;
    } catch (error) {
        console.error("❌ Food API call failed:", error);
        throw error;
    }
}

export async function sendUserConversationEncrypted(message, getCommonHeaders) {
    const urlParams = new URLSearchParams(window.location.search);
    const goqiiCoachID = urlParams.get("goqiiCoachId") || urlParams.get("goqiicoachid");
    if (goqiiCoachID === "") {
        return
    }
    const url = "https://apiv7.goqii.com/userchatconversation/send_user_conversation";
    let chatData = [
        {
            "imageUrl": "",
            "message": message,
            "messageTimestamp": Date.now().toString()
        }
    ];
    console.log(chatData);
    // Hard-coded encrypted payload from your example
    const body = {
        goqiiCoachId: goqiiCoachID,
        chatData: JSON.stringify(chatData)
    }

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify(body)
        });

        const result = await response.json();
        console.log("✅ send_user_conversation response:", result);
        return result;
    } catch (error) {
        console.error("❌ send_user_conversation failed:", error);
        throw error;
    }
}

export async function coachCallSelectedSlot(userDetails, apiKey, getCommonHeaders) {
    const params = {
        goqiiCoachId: userDetails.goqiiCoachId,
        goqiiuserid: userDetails.goqiiUserId,
        apikey: apiKey,
        goqiiaccesstoken: userDetails.goqiiAccessToken,
        appversion: userDetails.appVersion,
        apptype: userDetails.appType
    }

    // 2. Base64-encode the JSON payload
    const json = JSON.stringify(params);
    const data = btoa(json); // in Node.js: Buffer.from(json).toString('base64')

    // 4. Send the POST
    const response = await fetch(
        "https://apiv7.goqii.com/user/coach_call_selected_slot",
        {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify({ data })
        }
    );

    const result = await response.json();
    console.log("✅ coach slot response:", result);

    // 5. Return parsed JSON
    return result;
}

export async function fetchDoctorAppointmentSlot(getCommonHeaders) {
    const params = {
        "type": "",
        "queryDate": "2025-05-13",
        "memberId": ""
    }

    // 4. Send the POST
    const response = await fetch(
        "https://apiv7.goqii.com/user/fetch_doctor_appointment_slots",
        {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify(params)
        }
    );

    const result = await response.json();
    console.log("✅ Doctor slot response:", result);

    // 5. Return parsed JSON
    return result;
}

export async function scheduleCoachAppointment(appointmentSlot, appointmentDate, userDetails, apiKey, getCommonHeaders) {
    const urlParams = new URLSearchParams(window.location.search);
    const goqiiCoachID = urlParams.get("goqiiCoachId") || urlParams.get("goqiicoachid");
    if (goqiiCoachID === "") {
        return
    }
    console.log("▶️  Scheduling coach appointment:", { appointmentSlot, appointmentDate });

    const url = "https://apiv7.goqii.com/user/schedule_coach_appointment";
    const slotEncoded = encodeURIComponent(appointmentSlot);

    // build the exact payload keys the API wants
    const payload = {
        selectedSlot: "1",            // or pass this in as a parameter
        appointmentSlot: slotEncoded,    // "09:30%20pm"
        goqiiuserid: userDetails.goqiiUserId,    // your var, e.g. "116563"
        callType: "review",
        goqiiCoachId: goqiiCoachID,   // your var, e.g. "41036"
        apikey: apiKey,         // "whshf1wjy88ayld1h2ba6jqay2gay854"
        apptype: userDetails.appType,        // "ios"
        appointmentDate: appointmentDate,                   // "2025-05-13"
        goqiiaccesstoken: userDetails.goqiiAccessToken,
        appversion: userDetails.appVersion      // "274"
    };

    console.log("📤 payload:", payload);

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...getCommonHeaders()     // your h- headers (token, signature, etc.)
            },
            body: JSON.stringify(payload)
        });

        const result = await response.json();
        console.log("✅ schedule_coach_appointment response:", response.status, result);
        return result;
    } catch (err) {
        console.error("❌ schedule_coach_appointment failed:", err);
        throw err;
    }
}

export async function scheduleDoctorAppointment(time, date, getCommonHeaders) {
    const params = { "appointmentDate": date, "appointmentReason": "General", "appointmentTime": time, "memberId": "", "type": "" }

    // 4. Send the POST
    const response = await fetch(
        "https://apiv7.goqii.com/user/save_doctor_appointment",
        {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify(params)
        }
    );

    const result = await response.json();
    console.log("✅ Doctor appointment Booking response:", result);

    // 5. Return parsed JSON
    return result
}

export async function addGlucoseEntry(level, userDetails, apiKey, getCommonHeaders) {
    console.log("▶️  Adding glucose entry:", { level });

    // 1) build current datetime strings
    const now = new Date();
    const dateStr = now.toISOString().split("T")[0];            // "YYYY-MM-DD"
    const timeStr = now.toTimeString().split(" ")[0];           // "HH:MM:SS"
    const logDate = `${dateStr} ${timeStr}`;                    // e.g. "2025-05-13 14:45:30"
    const localId = Date.now().toString();                      // unique per-entry

    // 2) build the single-record array
    const record = {
        vitalType: "1",
        mealType: "1",  //mealType.toString(),
        localId: localId,
        level: level.toString(),
        serverId: "0",
        logDate,
        metric: "1",
        type: "2",
        subType: "0",
        logType: "1",
        status: "new"
    };

    // 3) assemble full payload
    const payload = {
        apptype: userDetails.appType,
        goqiiaccesstoken: userDetails.goqiiAccessToken,
        appversion: userDetails.appVersion,
        apikey: apiKey,
        goqiiuserid: userDetails.goqiiUserId,
        data: JSON.stringify([record])
    };

    // 4) POST to the endpoint
    try {
        const response = await fetch("https://apiv7.goqii.com/glucose/add_glucose", {
            method: "POST",
            headers: getCommonHeaders(),
            body: JSON.stringify(payload)
        });

        const result = await response.json();
        console.log("✅ add_glucose response:", response.status, result);
        return result;
    } catch (error) {
        console.error("❌ add_glucose failed:", error);
        throw error;
    }
}

export async function fetchMyOrders(getCommonHeaders) {
    console.log("▶️  Fetching orders");

    const url = "https://apiv7.goqii.com/store/fetch_my_orders_v2";

    // include pageId in the POST body
    const payload = { pageId: "1" };

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: getCommonHeaders(),   // your h- headers, tokens, etc.

            body: JSON.stringify(payload)
        });

        const result = await response.json();
        console.log("✅ fetch_my_orders_v2 response:", response.status, result);
        return result;
    } catch (err) {
        console.error("❌ fetch_my_orders_v2 failed:", err);
        throw err;
    }
}
